const locale = {
  general: {
    language: 'Français',
    cancel: 'Annuler',
    yes: 'Oui',
    no: 'Non',
    ok: 'Ok',
    apply: 'Appliquer',
    continue: 'Continuer',
    confirm: 'Compris',
    save: 'Enregistrer',
    close: 'Fermer',
    loading: 'Veuillez patienter...',
    errorHeader: 'Erreur',
    errorEmptyField: 'Champ obligatoire',
    errorEmptyFields: 'Le champ obligatoire est vide',
    errorInvalidEmail: 'Email non valide',
    successHeader: 'Réussi',
    successfullySaved: 'Enregistrement réussi',
    successfullyVerified: 'Vérification réussie',
    errorStampUpload: 'erreur de téléchargement du tampon'
  },
  oneTwoBuildNotifySales: {
    text: 'le couplage à 12Build n\'a pas encore été activé, vous pouvez le faire activer par votre gestionnaire Docstream.'
  },
  treeView: {
    rootFolderName: 'Bureau',
    title: 'Dossiers',
    allFolder: 'Tous les dossiers',
    favoriteFolder: 'Dossiers favoris',
    newDocs: 'Nouveaux documents',
    workBox: 'Boîte de travail',
    newDocsDescription: 'Documents des derniers 7 jours'
  },
  toolbar: {
    new: 'Nouveau',
    import: 'Importer document',
    newViaTemplate: 'Nouveau document de modèle',
    expected: 'Documents prévus',
    newFolder: 'Nouveau dossier',
    newFolderViaTemplate: 'Nouveau dossier de modèle',
    show: 'Consulter',
    edit: 'Modifier',
    publish: 'Publier',
    search: 'Chercher',
    status: 'Statut',
    stamp: 'Estampiller',
    QRCode: 'Code QR',
    message: 'Message',
    printOrder: 'Tâche d\'impression',
    version: 'Ecran de version',
    view: 'Image',
    extra: 'Extra'
  },
  mainNav: {
    documents: 'Documents',
    management: 'Gestion',
    messages: 'Messages',
    contacts: 'Contacts',
    procedures: 'Procédures'
  },
  login: {
    username: 'Nom d\'utilisateur',
    usernameWithEmail: 'E-mail',
    password: 'Mot de passe',
    login: 'Connnexion',
    or: 'ou',
    back: 'Retour',
    employeeOf: 'Collaborateur de Pro4all',
    portal: 'Portail Pro4all',
    reset: 'Réinitialiser mot de passe',
    resetText: 'Saisissez ici votre nouveau mot de passe.',
    resetBadPassFirst: 'Le mot de passe indiqué n\'est pas valable. Le mot de passe ne peut pas avoir été utilisé antérieurement, et doit au moins contenir',
    resetBadPassSecond: ' caractères, parmi lesquels ',
    resetBadPassThird: ' caractère spécial (par exemple !@#$%^&*).',
    resetDiffer: 'Les mots de passe ne correspondent pas.',
    resetSave: 'Enregistrer',
    resetNew: 'Nouveau mot de passe',
    resetConfirm: 'Confirmer mot de passe',
    resetSuccess: 'Le mot de passe est introduit. Revenez en arrière et connectez-vous avec votre nouveau mot de passe.',
    resetFail: 'Le lien n\'est pas correct ou n\'est plus valable.',
    forgotPassword: 'Mot de passe oublié ?',
    forgotPasswordText: 'Saisissez votre nom d\'utilisateur pour recevoir un nouveau mot de passe.',
    forgotPasswordTextWithEmail: 'Entrez votre email pour recevoir un nouveau mot de passe.',
    forgotPasswordFail: 'Aucun nom d\'utilisateur n\'a été indiqué.',
    forgotPasswordFailEmail: 'Format d\'e-mail non valide spécifié',
    forgotPasswordSuccessFirst: 'Si le nom d\'utilisateur existe dans Docstream, vous devriez recevoir un e-mail avec un lien avec lequel on peut introduire le mot de passe. Cette action peut au maximum ',
    forgotPasswordSuccessFirstWithEmail: 'Si l\'e-mail existe dans Docstream, vous devriez recevoir un e-mail avec un lien avec lequel vous pouvez saisir le mot de passe. Cette action peut tout au plus ',
    forgotPasswordSuccessSecond: ' être effectuée  fois par jour.',
    forgotPasswordSuccessTimeFirst: 'Attention : le lien envoyé est ',
    forgotPasswordSuccessTimeSecond: ' valable  minutes.',
    expired: 'Votre session est terminée.',
    expiredText: 'Votre session est terminée en raison de l\'inactivité dans docstream. Cliquez sur le bouton ci-dessous pour vous reconnecter.',
    doubleLogin: 'Nom d\'utilisateur déjà connecté!',
    doubleLoginFirstHeader: 'Cause:',
    doubleLoginFirstText: 'La raison de ce message est que vous êtes déjà connecté sur un autre ordinateur avec les mêmes données d\'utilisateur.',
    doubleLoginSecondHeader: 'Solution:',
    doubleLoginSecondText: 'Enregistrez d\'abord votre travail sur un autre ordinateur, puis déconnectez-vous et reconnectez-vous à nouveau.',
    wrongLoginTitle: 'Echec de la connexion',
    wrongLogin: 'Contrôlez les données et recommencez',
    wrongEmailFormat: 'Format d\'email non valide',
    wrongEmail: 'Entrez une adresse électronique valide',
    loginRequestError: 'Un problème est survenu lors de la connexion',
    introText: 'Gérez tous vos projets et documents dans un seul endroit synoptique',
    send: 'Envoyez e-mail',
    loggedOut: 'Vous êtes déconnecté.',
    loggedOutText: 'Vous êtes déconnecté de docstream. Cliquez sur le bouton ci-dessous pour vous recconnecter.',
    OIDCErrorHeader: 'Echec de connexion',
    OIDCErrorFirstText: 'Echec de connexion via votre compte externe. Il se peut que vous n\'ayez pas introduit de compte externe.',
    OIDCErrorSecondText: 'Pour ce faire, connectez-vous d\'abord avec vos données de connexion Docstream et créez un compte externe via [Extra -> Compte externe].',
    mfaTitle: 'Vérifiez votre compte',
    mfaDescription: 'Vous trouverez le code de vérification de deux étapes dans l\'appli d\'authentification.',
    mfaPlaceholder: 'Entrer code',
    mfaButton: 'Connexion',
    mfaTitleSetup: 'Vérifiez votre compte',
    mfaDescriptionSetup: 'Ouvrez l\'appli d\'authentification sur votre smartphone.',
    mfaTitleSetup2: 'Scanner',
    mfaDescriptionSetup2: 'Scannez le code QR dans l\'appli d\'authentification sur votre smartphone.',
    mfaTitleSetup3: 'Entrez le code',
    mfaDescriptionSetup3: 'Entrez ici les 6 chiffres qui apparaissent dans l\'appli d\'authentification.',
    mfaDescriptionCode: 'Utilisez le code suivant manuellement:',
    mfaButtonSetup: 'Confirmez code'
  },
  loginCarousel: {
    slideTitle: 'Rencontrez Prostream',
    slideText: 'La dernière façon de gérer des documents et des projets. {slideLinkText} pour plus d\'informations',
    slideLinkText: 'Cliquez ici'
  },
  newFolder: {
    title: 'Créer nouveau dossier',
    subTitle: 'Nom de dossier',
    inputText: 'Entrer nom de dossier',
    cancelButton: 'Annuler',
    acceptButton: 'Ok',
    errorMessage: 'Le nom de dossier doit comporter au minimum 1 caractère et au maximum 255 et n\'utilisez pas de caractères tels que : \\/:*?"<>|.'
  },
  usersInformation: {
    headerTitle: 'Informations de l\'utilisateur',
    tabs: {
      title: 'Paramètres',
      general: 'Généralités',
      personalInformation: 'Données à caractère personnel',
      companyInformation: 'Données professionnelles',
      signature: 'Signature',
      verify: 'authentification 2 facteurs',
      stamp: 'Estampiller'
    },
    buttons: {
      close: 'Annuler',
      save: 'Enregistrer'
    },
    general: {
      title: 'Généralités',
      text: 'Entrez ici vos paramètres généraux. Attention, toutes les modifications ont une influence sur tout l\'environnement.',
      username: 'Nom d\'utilisateur',
      name: 'Nom',
      email: 'Adresse électronique',
      toInform: 'Informer',
      dropdownPlaceholder: 'Sélectionner option...',
      dropdownOptions: ['Oui, sur tout', 'Oui, par dossier', 'Non', 'Oui, par dossier favori'],
      description: 'Description',
      password: 'Mot de passe',
      confirmPassword: 'Confirmez le mot de passe',
      passwordChange: 'Modifier',
      resetEmail: 'Envoyez email de réinitialisation'
    },
    personal: {
      title: 'Données à caractère personnel',
      text: 'Entrez ici vos paramètres généraux. Attention, toutes les modifications ont une influence sur tout l\'environnement.',
      firstName: 'Prénom',
      lastName: 'Nom',
      prefixes: 'Particule',
      email: 'Adresse électronique',
      workphone: 'Numéro professionnel',
      mobile: 'Numéro de portable',
      checkbox: 'Je souhaite recevoir la newsletter'
    },
    company: {
      title: 'Données professionnelles',
      text: 'Entrez ici vos paramètres généraux. Attention, toutes les modifications ont une influence sur tout l\'environnement.',
      name: 'Nom de l\'entreprise',
      function: 'Fonction'
    },
    signature: {
      title: 'Signature',
      text: 'Votre signature est utilisée dans toute la correspondance.'
    },
    verify: {
      title: 'authentification à 2 facteurs',
      text1: 'Scannez le code QR-code via une "appli d\'authentification à 2 facteurs" pour rendre votre compte plus sûr. Lorsque vous vous connectez quelque part, vous devez utiliser le code qui vous associe via l\'appli pour confirmer que vous voulez aussi vous connecter.',
      text2: 'Une fois scanné, un code s\'affiche. Entrez-le ci-dessous pour connecter l\'appli d\'authentification à 2 facteurs.',
      disabledText: 'L\'authentification à 2 facteurs a déjà été activée. Vous pouvez la désactiver ou récupérer le code TOIP pour partager votre compte ou ajouter à un \'coffre-fort à mots de passe’.',
      confirm: 'Confirmer',
      disable: 'déseactiver'
    },
    stamp: {
      title: 'Estampiller',
      text: 'Ajouter Estampiller',
      noImage: 'Pas d\'image',
      upload: 'Télécharger',
      fileExtension: 'Seules les images .PNG peuvent être utilisées comme cachet.'
    }
  },
  folderProperties: {
    general: {
      title: 'Généralités',
      form: {
        label1: 'Nom de dossier',
        label2: 'Dossier créé par',
        label3: 'Dossier créé le',
        label4: 'Contenu du dossier',
        label5: 'Ensemble de métadonnées',
        label6: 'Projet',
        label7: 'Projet Snagstream',
        notLinked: 'Non associé',
        checkbox1: 'Dossier de projet',
        checkbox2: 'Dossier confidentiel',
        unlinkButton: 'Dissocier'
      }
    },
    procedure: {
      title: 'Procédure',
      form: {
        checkbox: 'Commencer automatiquement une nouvelle procédure lors du placement d\'un document(version)',
        label1: 'Standard',
        label2: 'Propriétaire'
      }
    },
    requiredDocuments: {
      title: 'Documents requis',
      form: {
        label: {
          line1: 'Entrez ci-dessous les noms de document requis de ce dossier',
          line2: '(Chaque nom sur une nouvelle ligne)'
        },
        textareaPlaceholder: ''
      }
    }
  },
  folderRights: {
    header: {
      title: 'Droits sur',
      searchPlaceholder: 'Recherche…'
    },
    table: {
      header: {
        Name: {
          title: 'Nom',
          bodyTitle: 'Informations',
          bodyText: [
            'Certains droits ont 2 colonnes, on décrit ci-dessous ce qu\'ils contiennent.',
            'La première colonne contient le droit concerné pour le dossier actuel.',
            'La deuxième colonne indique que le droit concerné est aussi valable pour les sous-dossiers.'
          ]
        },
        IL: {
          bodyTitle: 'Lecteur interne',
          bodyText: [
            'Tous les documents sont visibles, quel que soit le statut du document.'
          ]
        },
        EL: {
          bodyTitle: 'Lecteur externe',
          bodyText: [
            'LEs documents avec le statut \'Approuver\' sont visibles.'
          ]
        },
        DL: {
          bodyTitle: 'Lecteur définitif',
          bodyText: [
            'Les documents qui ont les statuts \'Approuver\' et \'Finaliser\' sont visibles.'
          ]
        },
        ET: {
          bodyTitle: 'Membre d\'équipe externe',
          bodyText: [
            'Les documents avec le statut \'Approuver\' sont visibles.',
            'Les documents dont vous êtes l\'auteur sont visibles.',
            'Vous pouvez placer de nouveaux documents.',
            'Vous pouvez placer de nouvelles versions sous vos documents.',
            'Vous pouvez donner ou supprimer le statut \'Approuver\' aux documents.',
            'Vous pouvez seulement supprimer vos documents.'
          ]
        },
        A: {
          bodyTitle: 'Assistant',
          bodyText: [
            'Tous les documents sont visibles, quel que soit le statut du document.',
            'Vous pouvez placer de nouveaux documents.',
            'Vous pouvez placer de nouvelles versions sous des documents.',
            'Vous pouvez seulement supprimer vos documents.'
          ]
        },
        IT: {
          bodyTitle: 'Membre d\'équipe interne',
          bodyText: [
            'Tous les documents sont visibles, quel que soit le statut du document.',
            'Vous pouvez placer de nouveaux documents.',
            'Vous pouvez supprimer des documents.',
            'Vous pouvez placer de nouvelles versions sous des documents.',
            'Vous pouvez donner ou supprimer le statut \'Approuver\' aux documents.'
          ]
        },
        '+': {
          bodyTitle: 'Créer sous-dossiers',
          bodyText: [
            'Vous pouvez créér de nouveaux dossiers sous ce dossier.'
          ]
        },
        EV: {
          bodyTitle: 'Responsable final',
          bodyText: [
            'Vous pouvez donner ou supprimer le statut \'Finaliser\' aux documents.'
          ]
        },
        B: {
          bodyTitle: 'Gestionnaire',
          bodyText: [
            'Tous les documents sont visibles, quel que soit le statut du document.'
          ]
        },
        PB: {
          bodyTitle: 'Postbook gestionnaire',
          bodyText: [
            'Vous êtes le gestionnaire du livret.'
          ]
        },
        PC: {
          bodyTitle: 'Coordinateur de processus',
          bodyText: [
            'Vous pouvez associer des procédures aux documents.'
          ]
        },
        I: {
          bodyTitle: 'Informer',
          bodyText: [
            'La notification de courrier peut être activée ici pour les dossiers actuels et sous-jacents.'
          ]
        },
        Alternative: {
          EL: {
            bodyText: 'Les documents avec le statut \'{0}\' sont visibles.'
          },
          DL: {
            bodyText: 'Les documents avec le statut \'{0}\' et \'Finaliser\' sont visibles.'
          },
          ET: {
            bodyText1: 'Les documents avec le statut \'{0}\' sont visibles.',
            bodyText2: 'Les documents dont vous êtes l\'auteur sont visibles.',
            bodyText3: 'Vous pouvez placer de nouveaux documents.',
            bodyText4: 'Vous pouvez placer de nouvelles versions sous vos documents.',
            bodyText5: 'Vous pouvez donner ou supprimer le statut \'{0}\' aux documents.',
            bodyText6: 'Vous pouvez seulement supprimer vos documents.'
          },
          IT: {
            bodyText1: 'Tous les documents sont visibles, quel que soit le statut du document.',
            bodyText2: 'Vous pouvez placer de nouveaux documents.',
            bodyText3: 'Vous pouvez supprimer des documents.',
            bodyText4: 'Vous pouvez placer de nouvelles versions sous des documents.',
            bodyText5: 'Vous pouvez donner ou supprimer le statut \'{0}\' aux documents.'
          },
          EV: {
            bodyText: 'Vous pouvez donner aux documents le statut \' {0} \' ou annuler cela.'
          },
          Default: 'Approuver',
          DefaultFinal: 'Figer'
        }
      }
    },
    buttons: {
      cancel: 'Annuler',
      exchange: 'Echanger',
      modify: 'Modifier',
      close: 'Fermer',
      save: 'Enregistrer',
      removeAll: 'Supprimer tout'
    }
  },
  CommentDialog: {
    downloadAttachmentTitle: '{0} pièces jointes',
    closeButtonText: 'Fermer',
    downloadButton: 'Télécharger ({0})',
    errorMessage: 'The files you requested are not available or you do not have access to them'
  },
  DocumentGrid: {
    noOptionsAvailable: 'No options available',
    EmptyFolder: 'No documents available',
    DocumentNotLoaded: 'Unable to retrieve documents',
    searchingFilters: 'Filtres de recherche',
    selectedDocuments: '({0} document (s) sélectionné (s))',
    checkVersionError: 'Unable to check selected versions',
    loadingGridMessage: 'Chargement',
    LoadingErrorMessage: 'The current page could not be loaded, try again later or report the error',
    ApplyFilter: 'Appliquer le filtre',
    RemoveFilters: 'Supprimer le filtre',
    SearchAllFolders: 'rechercher dans tous les dossiers',
    ascending: 'Ascendant',
    descending: 'Descendant',
    facetFilter: 'Rechercher...',
    selectAll: 'Tout sélectionnert',
    deSelectAll: 'Désélectionner tout'
  }
}

export default locale



// WEBPACK FOOTER //
// ./src/localization/locales/fr.js